const API_URL = process.env.REACT_APP_API_URL;
import BaseApi from './baseApi';

class CategoryApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = '/dashboard';
  }

  fetchCategories(token, categoryData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-category-list`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: categoryData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  createCategory(token, categoryData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-category`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: categoryData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  updateCategory(token, categoryData) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-category`;
    const axiosRq = {
      url: endPoint,
      method: 'PUT',
      data: categoryData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  deleteCategory(token, categoryId) {
    const endPoint = `${API_URL}${this.baseUrl}/delete-category/${categoryId}`;
    const axiosRq = {
      url: endPoint,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  getCategoryDetails(token, categoryData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-category-details`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: categoryData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }
}

const categoryApi = new CategoryApi();

export default categoryApi;
